/* R3 gallery + inquiry. No cart hooks, app overrides, contact-data storage or network calls. */
(function () {
  'use strict';
  function track(root, name, extra) {
    var detail = Object.assign({ event: 'ggb_' + name, release: '3', page_type: root.dataset.page }, extra || {});
    document.dispatchEvent(new CustomEvent('ggb:measurement', { detail: detail }));
    // Use the store's existing consent and GTM setup. Missing consent fails closed.
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && privacy.analyticsProcessingAllowed() === true && Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
    } catch (_) { /* Analytics must never interrupt shopping or an inquiry. */ }
  }
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var cards = Array.from(root.querySelectorAll('[data-look-card]'));
    var filters = Array.from(root.querySelectorAll('[data-look-filter]'));
    var finish = root.querySelector('[data-finish-filter]');
    var count = root.querySelector('[data-result-count]');
    var empty = root.querySelector('[data-no-results]');
    var form = root.querySelector('[data-team-inquiry]');
    var select = form && form.querySelector('[data-selected-look]');
    var status = form && form.querySelector('[data-look-status]');
    var family = 'all';
    if (finish) Array.from(finish.options).forEach(function (option) {
      var available = option.value === 'all' || cards.some(function (card) { return card.dataset.finish === option.value; });
      option.hidden = !available; option.disabled = !available;
    });
    function applyFilters() {
      var shown = 0;
      cards.forEach(function (card) {
        var match = (family === 'all' || card.dataset.family === family) && (!finish || finish.value === 'all' || card.dataset.finish === finish.value);
        card.hidden = !match;
        if (match) shown++;
      });
      if (count) count.textContent = shown + (shown === 1 ? ' look' : ' looks');
      if (empty) empty.hidden = shown !== 0;
    }
    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        family = button.dataset.lookFilter;
        filters.forEach(function (other) { other.setAttribute('aria-pressed', String(other === button)); });
        applyFilters();
      });
    });
    if (finish) finish.addEventListener('change', applyFilters);
    var reset = root.querySelector('[data-reset-filters]');
    if (reset) reset.addEventListener('click', function () {
      family = 'all'; finish.value = 'all';
      filters.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.lookFilter === 'all')); });
      applyFilters(); filters[0].focus();
    });
    function choose(id, announce) {
      if (!select) return false;
      var option = Array.from(select.options).find(function (o) { return o.dataset.lookId === id; });
      if (!option) return false;
      select.value = option.value;
      if (status && announce) status.textContent = option.textContent + ' selected. Tell us a little about your team below.';
      return true;
    }
    function updateURL(id) {
      try {
        var url = new URL(window.location.href);
        if (id) url.searchParams.set('look', id); else url.searchParams.delete('look');
        url.hash = 'team-inquiry';
        window.history.replaceState(null, '', url.pathname + url.search + url.hash);
      } catch (_) { /* The native link and form still work without history access. */ }
    }
    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-look-select]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var id = link.dataset.lookSelect;
      track(root, 'look_select', { look_id: id });
      if (choose(id, true)) {
        event.preventDefault(); updateURL(id);
        var section = root.querySelector('#team-inquiry');
        select.focus({ preventScroll: true });
        section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    });
    cards.forEach(function (card) {
      var details = card.querySelector('details');
      if (details) details.addEventListener('toggle', function () {
        if (details.open) track(root, 'look_view', { look_id: card.dataset.lookCard });
      });
    });
    var viewed = false;
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!viewed && entries.some(function (e) { return e.isIntersecting; })) {
          viewed = true; track(root, 'gallery_view', { look_count: cards.length }); observer.disconnect();
        }
      }, { threshold: 0.1 });
      var gallery = root.querySelector('[data-gallery-grid]');
      if (gallery) observer.observe(gallery);
    }
    if (form && select) {
      // Accept only IDs already rendered by Shopify, never arbitrary URL text.
      choose(new URLSearchParams(window.location.search).get('look'), true);
      select.addEventListener('change', function () {
        var id = select.selectedOptions[0].dataset.lookId || '';
        if (status) status.textContent = '';
        updateURL(id);
      });
      var started = false;
      form.addEventListener('focusin', function (event) {
        if (!started && /^(INPUT|SELECT|TEXTAREA)$/.test(event.target.tagName)) { started = true; track(root, 'inquiry_start'); }
      });
      form.addEventListener('submit', function () {
        if (form.checkValidity()) track(root, 'inquiry_submit', { look_id: select.selectedOptions[0].dataset.lookId || 'undecided' });
        // Shopify owns submission, validation, spam protection and delivery.
      });
    }
    if (form) {
      var success = form.querySelector('[data-inquiry-success]');
      var error = form.querySelector('[data-inquiry-error]');
      if (success) {
        try {
          if (!window.sessionStorage.getItem('ggb-r3-inquiry-success')) { track(root, 'inquiry_success'); window.sessionStorage.setItem('ggb-r3-inquiry-success', '1'); }
        } catch (_) { track(root, 'inquiry_success'); }
      } else {
        try { window.sessionStorage.removeItem('ggb-r3-inquiry-success'); } catch (_) {}
      }
      // The server-rendered result owns success/error. Bring it into view after
      // Shopify's native return navigation; a URL flag alone never creates a result.
      var result = success || error;
      if (result) {
        result.focus({ preventScroll: true });
        result.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    }
    applyFilters();
  }
  function boot(scope) {
    if (scope.matches && scope.matches('[data-ggb-gallery]')) initialize(scope);
    scope.querySelectorAll('[data-ggb-gallery]').forEach(initialize);
  }
  if (!window.ggbRelease3Bound) {
    window.ggbRelease3Bound = true;
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
    document.addEventListener('shopify:block:select', function (event) {
      var card = document.querySelector('[data-shopify-block-id="' + CSS.escape(event.detail.blockId) + '"]');
      if (card) { card.hidden = false; card.scrollIntoView({ block: 'center' }); }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
    else boot(document);
  }
}());
